import type { CSSProperties, ReactNode } from "react";
import { Card } from "primereact/card";

/** Matches YouTube scorecard metadata tab content card. */
export const BANNER_DASHBOARD_CONTENT_CARD_STYLE: CSSProperties = {
  marginTop: "0.3rem",
  marginBottom: "2rem",
  boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.1)",
  borderRadius: "7px",
};

/** Grey page background is from PageContainer; this centers tab content like scorecard. */
export function BannerDashboardPageShell({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <div
      className="main-content"
      style={{
        width: "96%",
        margin: "0 auto",
      }}
    >
      <Card
        unstyled
        style={{
          marginTop: "2rem",
          boxShadow: "none",
        }}
      >
        {children}
      </Card>
    </div>
  );
}

export function BannerDashboardTabLayout({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <div
      style={{
        width: "100%",
        marginTop: "-30px",
        marginBottom: "-30px",
      }}
    >
      <Card className="p-fluid" style={BANNER_DASHBOARD_CONTENT_CARD_STYLE}>
        {children}
      </Card>
    </div>
  );
}
